export default "__VITE_ASSET__nYmObBuY__"